import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  list: {
    '& > .MuiCard-root + .MuiCard-root': {
      marginTop: theme.spacing(2), //Add margin when two groups are next to each other
    },
    '& .MuiCard-root + .MuiListItem-container': {
      border: 'none', //Remove border-top when item follows a group
    },
    marginBottom: theme.spacing(2),
  },
  outsideInterval: {
    '& button': {
      color: theme.palette.grey[400],
    },
  },
  warningText: {
    color: theme.palette.warning.dark,
  },
  lightQuestion: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(4),
    padding: theme.spacing(4, 2, 5),
    borderTop: `1px solid ${theme.palette.grey[100]}`,
    borderBottom: `1px solid ${theme.palette.grey[100]}`,
    [theme.breakpoints.down('md')]: {
      display: 'block',
      paddingRight: theme.spacing(2),
    },
  },
  lightQuestionText: {
    flex: '0 0 34%',
    minWidth: 0,
    paddingTop: theme.spacing(1.5),
    paddingLeft: theme.spacing(1),
    '& h3': {
      lineHeight: 1.35,
      margin: 0,
    },
  },
  lightQuestionActions: {
    display: 'flex',
    alignItems: 'flex-start',
    flex: '1 1 66%',
    minWidth: 0,
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(2),
      width: '100%',
    },
  },
  lightQuestionOptions: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '100%',
    marginTop: theme.spacing(2),
    '& .MuiFormControlLabel-root': {
      flex: '1 1 0',
      minWidth: 0,
      marginLeft: 0,
      marginRight: 0,
      textAlign: 'center',
      alignItems: 'center',
      justifyContent: 'flex-end',
      height: theme.spacing(13),
    },
    '& .MuiFormControlLabel-label': {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'center',
      lineHeight: 1.25,
      whiteSpace: 'normal',
      padding: theme.spacing(0, 1),
      minHeight: theme.spacing(7),
      marginBottom: theme.spacing(1),
    },
    '& .MuiRadio-root': {
      paddingTop: 0,
      paddingBottom: 0,
    },
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      '& .MuiFormControlLabel-root': {
        flexDirection: 'row-reverse',
        justifyContent: 'space-between',
        width: '100%',
      },
      '& .MuiFormControlLabel-label': {
        textAlign: 'left',
      },
    },
  },
}));
